<div class="flex-center" id="footerDiv">
  <!-- Copyright © MAY 2022, WhatsLoan.com. All Rights Reserved. -->
  <div *ngIf="showOrHide" class="display-flex">
    <p class="font-size-small">Powered by</p>
    <img class="logo fx-hide-xs h-32px mr-16px" src="../../assets/whatsloan.png" alt="WhatsLoan">
  </div>
</div>

